<template>
  <h2 class="section-title" v-in-viewport="{ top: -50 }">
    <span class="section-title__content">{{ title }}</span>
  </h2>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-title {
    @include font-style-extreme;
    @include font-cut;
    text-align: right;
    position: relative;

    &:not(&--rotated) &__content {
      display: block;
      opacity: 0;
      transform: translate3d(0, 100%, 0);
      transition: opacity .7s,
                  transform .45s;
    }

    &.in-viewport:not(&--rotated) &__content {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }

    &--rotated {
      display: inline-block;
      bottom: 100%;
      width: 100%;
      position: relative;
      margin-bottom: 35px;
      @include media-down(sm) {
        overflow: visible;
        max-height: none;
      }
      @include media-up(sm) {
        margin-bottom: 54px;
      }
      @include media-up(md) {
        position: absolute;
        right: 0;
        transform-origin: left bottom;
        transform: translateX(100%) rotate(-90deg);
        width: auto;
        margin-bottom: 63px;
      }
      @include media-up(lg) {
        margin-bottom: 66px;
      }

    }

    .section-projects & {
      margin-bottom: 22px;

      @include media-up(sm) {
        margin-bottom: 46px;
      }
      @include media-up(lg) {
        margin-bottom: 50px;
      }
    }

    .section-contact & {
      margin-bottom: 26px;

      @include media-up(lg) {
        margin-bottom: 50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SectionTitle.vue